/** Banner admin náhledu — viditelný přes celou šířku, nad Topbar/Sidebar.
 *  Zobrazuje se jen když auth-provider detekoval impersonaci (m-CRM admin
 *  bez partner_users mappingu s aktivním partner_impersonations záznamem). */

import { useState } from "react";
import { useAuth } from "@/auth/auth-provider";
import { authedFetch } from "@/lib/auth";
import { EDGE_FUNCTION_BASE } from "@/lib/supabase";
import { t } from "@/i18n/de";

export function ImpersonationBanner() {
  const { partner, signOut } = useAuth();
  const [busy, setBusy] = useState(false);

  const stopPreview = async () => {
    setBusy(true);
    try {
      await authedFetch(`${EDGE_FUNCTION_BASE}/partner-portal/impersonate-stop`, {
        method: "POST",
        body: "{}",
      });
    } catch {
      // i při chybě odhlásíme — bez session náhled stejně končí
    }
    await signOut();
  };

  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "6px 16px",
        background: "var(--gold)",
        color: "#1A1408",
        fontSize: 12.5,
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      <span>
        {t.impersonation.banner(partner?.company_name || partner?.contact_name || "…")}
        <span style={{ fontWeight: 400, marginLeft: 8 }}>{t.impersonation.bannerNote}</span>
      </span>
      <button
        type="button"
        onClick={() => void stopPreview()}
        disabled={busy}
        style={{
          border: "1px solid #1A1408",
          borderRadius: 6,
          background: "transparent",
          color: "#1A1408",
          fontSize: 12,
          fontWeight: 600,
          padding: "2px 10px",
          cursor: "pointer",
          opacity: busy ? 0.6 : 1,
        }}
      >
        {t.impersonation.stop}
      </button>
    </div>
  );
}
